import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductService } from '../../services/product.service';
import {
	ApiService,
	BadgeComponent,
	ButtonComponent,
	CapitalizeSpecificWordsPipe,
	GenericModalComponent,
	ModalComponent,
	NotificationComponent,
	SrPunctuationPipe,
	SvgIconComponent,
} from '@woolworthsnz/styleguide';
import { StampComponent } from '../stamp/stamp.component';
import { AddToTrolleyComponent } from '../add-to-trolley/add-to-trolley.component';
import { EachKgSelectorComponent } from '../each-kg-selector/each-kg-selector.component';
import { PriceComponent } from '../price/price.component';
import { PriceMetaComponent } from '../price-meta/price-meta.component';
import { PriceMetaV2Component } from '../price-meta-v2/price-meta-v2.component';
import { PriceSingleUnitAverageComponent } from '../price-single-unit-average/price-single-unit-average.component';
import { ProductImageComponent } from '../image/image.component';
import { RouterLink } from '@angular/router';
import { FuelTagComponent } from '../fuel-tag/fuel-tag.component';
import { TagComponent } from '../tag/tag.component';
import { NgIf, NgClass, NgStyle, TitleCasePipe } from '@angular/common';
import { ShopperNotesComponent } from '../shopper-notes/shopper-notes.component';
import { PortalModule } from '@angular/cdk/portal';

@Component({
	selector: 'product-stamp-grid',
	templateUrl: './stamp-grid.component.html',
	styleUrls: ['./stamp-grid.component.scss'],
	providers: [ApiService, ProductService],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		PortalModule,
		ModalComponent,
		ShopperNotesComponent,
		GenericModalComponent,
		NgIf,
		NgStyle,
		NgClass,
		TagComponent,
		FuelTagComponent,
		RouterLink,
		ProductImageComponent,
		SvgIconComponent,
		PriceSingleUnitAverageComponent,
		PriceMetaComponent,
		PriceMetaV2Component,
		PriceComponent,
		EachKgSelectorComponent,
		NotificationComponent,
		AddToTrolleyComponent,
		ButtonComponent,
		TitleCasePipe,
		CapitalizeSpecificWordsPipe,
		SrPunctuationPipe,
		BadgeComponent,
	],
})
export class StampGridComponent extends StampComponent {
	// Avoid putting logic here, all logic should come from the base class
}
